/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BacktestListResponse,
  BacktestResponse,
  CreateBacktestRequest,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * List backtests visible to the current user.
 * @summary List Backtests
 */
export const listBacktests = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<BacktestListResponse>(
      {url: `/backtests`, method: 'GET', signal
    },
      options);
    }




export const getListBacktestsQueryKey = () => {
    return [
    `/backtests`
    ] as const;
    }


export const getListBacktestsQueryOptions = <TData = Awaited<ReturnType<typeof listBacktests>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBacktests>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBacktestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBacktests>>> = ({ signal }) => listBacktests(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBacktests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBacktestsQueryResult = NonNullable<Awaited<ReturnType<typeof listBacktests>>>
export type ListBacktestsQueryError = unknown


/**
 * @summary List Backtests
 */

export function useListBacktests<TData = Awaited<ReturnType<typeof listBacktests>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBacktests>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBacktestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Submit a backtest for async execution against a strategy version.
 * @summary Create Backtest
 */
export const createBacktest = (
    createBacktestRequest: CreateBacktestRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<BacktestResponse>(
      {url: `/backtests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBacktestRequest, signal
    },
      options);
    }




export const getCreateBacktestMutationKey = () => ['createBacktest'] as const;

export const getCreateBacktestMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBacktest>>, TError,CreateBacktestMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createBacktest>>, TError,CreateBacktestMutationVariables, TContext> => {

const mutationKey = getCreateBacktestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBacktest>>, CreateBacktestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createBacktest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBacktestMutationResult = NonNullable<Awaited<ReturnType<typeof createBacktest>>>
    export type CreateBacktestMutationBody = CreateBacktestRequest
    export type CreateBacktestMutationError = HTTPValidationError
    export type CreateBacktestMutationVariables = {data: CreateBacktestRequest}

    /**
 * @summary Create Backtest
 */
export const useCreateBacktest = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBacktest>>, TError,CreateBacktestMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBacktest>>,
        TError,
        CreateBacktestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBacktestMutationOptions(options));
    }
